var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHelpIcnRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_115_289",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#1ba7ca"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_115_289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 21.1345L12.3463 18.5H11.5C9.27433 18.5 7.38458 17.7231 5.83075 16.1693C4.27692 14.6154 3.5 12.7257 3.5 10.5C3.5 8.27433 4.27692 6.38458 5.83075 4.83075C7.38458 3.27692 9.27433 2.5 11.5 2.5C12.6128 2.5 13.6529 2.708 14.6202 3.124C15.5876 3.54 16.4347 4.1115 17.1615 4.8385C17.8885 5.56533 18.46 6.41242 18.876 7.37975C19.292 8.34708 19.5 9.38717 19.5 10.5C19.5 11.6347 19.3231 12.7241 18.9693 13.7683C18.6154 14.8124 18.1292 15.7893 17.5105 16.699C16.892 17.6087 16.1545 18.4394 15.298 19.1913C14.4417 19.9433 13.509 20.591 12.5 21.1345ZM14 18.35C15.1833 17.35 16.1458 16.1792 16.8875 14.8375C17.6292 13.4958 18 12.05 18 10.5C18 8.68333 17.3708 7.14583 16.1125 5.8875C14.8542 4.62917 13.3167 4 11.5 4C9.68333 4 8.14583 4.62917 6.8875 5.8875C5.62917 7.14583 5 8.68333 5 10.5C5 12.3167 5.62917 13.8542 6.8875 15.1125C8.14583 16.3708 9.68333 17 11.5 17H14V18.35ZM11.5037 15.773C11.7487 15.773 11.9568 15.6874 12.128 15.5163C12.299 15.3451 12.3845 15.1371 12.3845 14.8923C12.3845 14.6474 12.299 14.4394 12.128 14.2683C11.9568 14.0971 11.7487 14.0115 11.5037 14.0115C11.2589 14.0115 11.0509 14.0971 10.8798 14.2683C10.7086 14.4394 10.623 14.6474 10.623 14.8923C10.623 15.1371 10.7086 15.3451 10.8798 15.5163C11.0509 15.6874 11.2589 15.773 11.5037 15.773ZM10.923 12.723H12.1152C12.1281 12.268 12.1926 11.9308 12.3088 11.7115C12.4248 11.4923 12.7398 11.1257 13.2538 10.6115C13.5474 10.318 13.7863 10.009 13.9703 9.6845C14.1543 9.36017 14.2462 9.00125 14.2462 8.60775C14.2462 7.82175 13.9779 7.2195 13.4413 6.801C12.9048 6.38233 12.2641 6.173 11.5192 6.173C10.8436 6.173 10.2734 6.35958 9.80875 6.73275C9.34392 7.10575 9.0115 7.55508 8.8115 8.08075L9.923 8.51525C10.032 8.22558 10.2096 7.95125 10.4558 7.69225C10.7019 7.43325 11.0564 7.30375 11.5192 7.30375C12.0269 7.30375 12.4045 7.44317 12.652 7.722C12.8993 8.001 13.023 8.3065 13.023 8.6385C13.023 8.9475 12.9381 9.21608 12.7683 9.44425C12.5984 9.67242 12.3872 9.91283 12.1348 10.1655C11.6026 10.627 11.2676 11.0147 11.1298 11.3287C10.9919 11.6429 10.923 12.1077 10.923 12.723Z",
    fill: "#1ba7ca"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHelpIcnRed);
export default __webpack_public_path__ + "static/media/HelpIcnRed.6b92408ea3c59c0a862c13c1513412a6.svg";
export { ForwardRef as ReactComponent };